module.exports=Array.isArray||function(r){return"[object Array]"==Object.prototype.toString.call(r)};